import { render } from "./TermsFollowModal.vue?vue&type=template&id=dcbd8b38"
import script from "./TermsFollowModal.vue?vue&type=script&lang=js"
export * from "./TermsFollowModal.vue?vue&type=script&lang=js"

import "./TermsFollowModal.vue?vue&type=style&index=0&id=dcbd8b38&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__